import React from 'react';
import './VideoBackground.css';
import videoSource from '../img/bg_waves_abtract_theme_trapcode.webm';

import bdImg from '../img/companyLogo/ic-1-bd-soft-distribution.webp';
import cacheDigitechImg from '../img/companyLogo/ic-2-cache-digitech.webp';
import handshakeImg from '../img/companyLogo/ic-3-3handshake.webp';
import dbinformaticsImg from '../img/companyLogo/ic-4-dbinformatics.webp';
import cybernxImg from '../img/companyLogo/ic-5-cybernx.webp';
import bbprofessionalsImg from '../img/companyLogo/ic-6-bbprofessionals.webp';
import vservImg from '../img/companyLogo/ic-7-vserv-infosystems.webp';
import fruxImg from '../img/companyLogo/ic-8-frux-tech.webp';
import ternatetechsoleImg from '../img/companyLogo/ic-9-ternate-techsole.webp';
import globalsignImg from '../img/companyLogo/ic-10-globalsign.webp';
import aadishImg from '../img/companyLogo/ic-11-aadishtech.webp';
import cyshieldImg from '../img/companyLogo/ic-12-cyshield.webp';
import whizImg from '../img/companyLogo/ic-13-whiz-works.webp';
import alphaImg from '../img/companyLogo/ic-14-alpha1-it-india.webp';
import aicyberImg from '../img/companyLogo/ic-15-aicyberwatch.webp';
import deltaImg from '../img/companyLogo/ic-16-delta-it-network.webp';
import unizentImg from '../img/companyLogo/ic-17-unizent.webp';
import regentImg from '../img/companyLogo/ic-18-regent.webp';
import unitasysImg from '../img/companyLogo/ic-19-unitasys.webp';
import techjockeyImg from '../img/companyLogo/ic-20-techjockey.webp';
import capterraImg from '../img/companyLogo/ic-21-capterra.webp';
import softwaresuggestImg from '../img/companyLogo/ic-22-software-suggest.webp';
import g2Img from '../img/companyLogo/ic-23-g2.webp';
import masImg from '../img/companyLogo/ic-24-mas-live-india.webp';

import Card from './Card';
import { Box } from '@mui/material';

const arr = [
    {
        logo: bdImg,
        name: "BD Software Distribution",
        country: "India",
        link: "https://bdsoft.in/"
    },
    {
        logo: cacheDigitechImg,
        name: "Cache Digitech",
        country: "India",
        link: "https://cachedigitech.com/"
    },
    {
        logo: handshakeImg,
        name: "3Handshake Innovation",
        country: "India",
        link: "https://3handshake.com/"
    },
    {
        logo: dbinformaticsImg,
        name: "DB Informatics",
        country: "India",
        link: "https://dagarbrothers.com/"
    },
    {
        logo: cybernxImg,
        name: "CyberNX",
        country: "India",
        link: "https://www.cybernx.com/"
    },
    {
        logo: bbprofessionalsImg,
        name: "BB Professionals",
        country: "India",
        link: "https://www.bbp.in/"
    },
    {
        logo: vservImg,
        name: "Vserv Infosystems",
        country: "India",
        link: "https://vservit.com/"
    },
    {
        logo: fruxImg,
        name: "Frux Technologies",
        country: "India",
        link: "https://www.fruxtech.com/"
    },
    {
        logo:  ternatetechsoleImg,
        name: "Ternate Techsol",
        country: "India",
        link: "https://ternate.in/"
    },
    {
        logo: globalsignImg,
        name: "GlobalSign",
        country: "India",
        link: "https://www.globalsign.com/"
    },
    {
        logo: aadishImg,
        name: "Aadish Technologies",
        country: "India",
        link: "http://aadishtech.com/"
    },
    {
        logo: cyshieldImg,
        name: "Cyshield",
        country: "India",
        link: "https://www.cyshield.in/"
    },
    {
        logo: whizImg,
        name: "Whiz Works",
        country: "India",
        link: "https://whiz-works.com/"
    },
    {
        logo: alphaImg,
        name: "Alpha1 IT",
        country: "India",
        link: "https://alpha1it.com/"
    },
    {
        logo: aicyberImg,
        name: "AI Cyber Watch",
        country: "India",
        link: "https://www.aicyberwatch.com"
    },
    {
        logo: deltaImg,
        name: "Delta IT Networks",
        country: "India",
        link: "https://www.deltaitnetwork.com/"
    },
    {
        logo: unizentImg,
        name: "Unizent Technologies",
        country: "India",
        link: "https://unizent.com/"
    },
    {
        logo: regentImg,
        name: "Regent Digitech",
        country: "India",
        link: "https://www.regentdigitech.com/"
    },
    {
        logo: unitasysImg,
        name: "Unitasys",
        country: "India",
        link: "https://unitasys.com/"
    },
    {
        logo: techjockeyImg,
        name: "Techjockey Infotech",
        country: "India",
        link: "https://www.techjockey.com/"
    },
    {
        logo: capterraImg,
        name: "Capterra",
        country: "USA",
        link: "https://www.capterra.com/"
    },
    {
        logo: softwaresuggestImg,
        name: "Software Suggest",
        country: "India",
        link: "https://www.softwaresuggest.com/"
    },
    {
        logo: g2Img,
        name: "G2",
        country: "USA",
        link: "https://www.g2.com/"
    },
    {
        logo: masImg,
        name: "Mas Live",
        country: "India",
        link: "https://maslindia.com/"
    }
]


function VideoBackground() {
    return (
        <div className="video-background">
        <video autoPlay muted loop>
                <source src={videoSource} type="video/mp4" />
        </video>
          
            <div className="content-overlay" style={{ marginLeft: "auto", marginRight: "auto" , width: "100%"}}>
                <h2 style={{ font: "normal normal bold 48px/72px Poppins", color: "#003FB9", marginBottom: "48px" }}>Our Channel Partners</h2>
                    <Box sx={{ display: "flex", marginLeft: 'auto', marginRight: "auto", flexWrap: "wrap", gridTemplateColumns: {lg: "repeat(auto-fill , minmax(250px, 1fr))", md: "repeat(auto-fill , minmax(250px, 1fr))", xs: "repeat(auto-fill , minmax(140px, 1fr))"}, columnGap: "32px", width: {xs: "90%", lg: "80%"}, justifyContent: "center", justifyItems: "center"}}>
                        {arr.map((e, index) => (
                            <Card index={index} logo={e.logo} name={e.name} country={e.country} link={e.link} />
                        ))}
                    </Box>
            </div>
        </div>
    );
}

export default VideoBackground;
